import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

function AdminLayout() {
  return (
    <div className="page admin-panel-page">
      <header className="page-header">
        <span className="page-eyebrow">Admin</span>
        <h1>Admin dashboard</h1>
        <p className="page-subtitle">Quick access to analytics and administrative tools.</p>
      </header>

      <section className="panel admin-actions">
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <NavLink to="/admin" end className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Overview
          </NavLink>
          <NavLink to="/admin/ads" className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Ads
          </NavLink>
          <NavLink to="/admin/users" className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Users
          </NavLink>
          <NavLink to="/admin/payments" className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Payments
          </NavLink>
          <div style={{ marginLeft: 'auto' }} className="text-muted small">Note: server-side admin gating applies.</div>
        </div>
      </section>

      <main style={{ marginTop: 16 }}>
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
